import React from 'react';
import Modal from './Modal';
import Button from './Button';
import './ConfirmDialog.css';

const ConfirmDialog = ({
  isOpen,
  onConfirm,
  onCancel,
  title = 'Are you sure?',
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  variant = 'danger',
  icon,
  children,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      size="sm"
      className="p-confirm"
      footer={
        <>
          <Button variant="secondary" onClick={onCancel}>
            {cancelLabel}
          </Button>
          <Button variant={variant} onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      <div className="p-confirm__content">
        {icon && <div className="p-confirm__icon">{icon}</div>}
        <h3 className="p-confirm__title">{title}</h3>
        {message && <p className="p-confirm__message">{message}</p>}
        {children}
      </div>
    </Modal>
  );
};

export default ConfirmDialog;
